<template>
  <div>
    <DefaultPage id="financials">
      <div class="financials">
        <div class="hero hero-tall">
          <img class="line line-purple-top" src="~@/assets/line-purple-top.png" alt=""/>
          <div class="hero-flex-wrap">
            <div class="grid-container">
              <div class="grid-x grid-margin-x">
                <div class="cell large-8">
                  <div class="hero__call">
                    <h1
                      class="hero__headline__small"
                      data-aos="fade-right"
                      data-aos-duration="1000"
                    >
                      Taking good care of the <br class="hide-for-small-only"/>resources entrusted to us.
                    </h1>
                    <div
                      data-aos="fade-up"
                      data-aos-duration="1000"
                    >
                      <a
                        :href="`${baseUrl}SVMIC 2023 Annual Report.pdf`"
                        download="SVMIC 2023 Annual Report"
                        class="financials__hero-button button large hollow"
                      >
                        Download the PDF
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="orbs-bg">
          <div
            class="orb purple"
            style="top: -100px; left: -200px;"
          ></div>
          <ContentSection id="highlights"
                          title="Financial Highlights"
                          class="financial-section">
            <div class="grid-container">
              <div class="grid-x">
                <div class="cell" data-aos="fade-up">
                  <div class="table-scroll">
                    <table class="align-table-1">
                      <thead>
                      <tr>
                        <th><h4>At Year End</h4>
                        <p>($ in thousands)</p></th>
                        <th><h4>2019</h4></th>
                        <th><h4>2020</h4></th>
                        <th><h4>2021</h4></th>
                        <th><h4>2022</h4></th>
                        <th><h4>2023</h4></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>Cash and Invested Assets</td>
                        <td class="number">1,249,626</td>
                        <td class="number">1,294,540</td>
                        <td class="number">1,390,803</td>
                        <td class="number">1,357,781</td>
                        <td class="number">1,442,715</td>
                      </tr>
                      <tr>
                        <td>Total Assets</td>
                        <td class="number">1,278,382</td>
                        <td class="number">1,321,878</td>
                        <td class="number">1,415,225</td>
                        <td class="number">1,385,631</td>
                        <td class="number">1,473,577</td>
                      </tr>
                      <tr>
                        <td>Loss &amp; Loss Adjustment Expense Reserves</td>
                        <td class="number">455,000</td>
                        <td class="number">456,000</td>
                        <td class="number">468,500</td>
                        <td class="number">461,000</td>
                        <td class="number">488,000</td>
                      </tr>
                      <tr>
                        <td>Policyholders’ Surplus</td>
                        <td class="number">671,735</td>
                        <td class="number">705,694</td>
                        <td class="number">778,138</td>
                        <td class="number">766,831</td>
                        <td class="number">821,076</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="separate-tables"><!--x--></div>
                  <div class="table-scroll">
                    <table class="align-table-1">
                      <thead>
                      <tr>
                        <th><h4>For The Year</h4>
                          <p>($ in thousands)</p></th>
                        <th><h4>2019</h4></th>
                        <th><h4>2020</h4></th>
                        <th><h4>2021</h4></th>
                        <th><h4>2022</h4></th>
                        <th><h4>2023</h4></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>Gross Written Premium</td>
                        <td class="number">119,235</td>
                        <td class="number">113,815</td>
                        <td class="number">121,824</td>
                        <td class="number">137,233</td>
                        <td class="number">145,691</td>
                      </tr>
                      <tr>
                        <td>Net Investment Income</td>
                        <td class="number">29,829</td>
                        <td class="number">28,148</td>
                        <td class="number">26,398</td>
                        <td class="number">35,345</td>
                        <td class="number">35,550</td>
                      </tr>
                      <tr>
                        <td>Net Paid Loss &amp; Loss Adjustment Expenses</td>
                        <td class="number">99,472</td>
                        <td class="number">80,225</td>
                        <td class="number">72,699</td>
                        <td class="number">91,332</td>
                        <td class="number">80,594</td>
                      </tr>
                      <tr>
                        <td>Policyholders’ Dividends Declared</td>
                        <td class="number">7,000</td>
                        <td class="number">7,000</td>
                        <td class="number">7,000</td>
                        <td class="number">7,500</td>
                        <td class="number">8,500</td>
                      </tr>
                      <tr>
                        <td>Net Income</td>
                        <td class="number">22,074</td>
                        <td class="number">23,853</td>
                        <td class="number">17,077</td>
                        <td class="number">21,669</td>
                        <td class="number">16,288</td>
                      </tr>
                      <tr class="spacer-row"></tr>
                      <tr>
                        <td>Cumulative Dividends and Return of Capital</td>
                        <td class="number">370,500</td>
                        <td class="number">377,500</td>
                        <td class="number">384,500</td>
                        <td class="number">392,000</td>
                        <td class="number">400,500</td>
                      </tr>
                      <tr>
                        <td>Cumulative Mutual Value Plan Allocations</td>
                        <td class="number">87,143</td>
                        <td class="number">97,918</td>
                        <td class="number">110,888</td>
                        <td class="number">122,475</td>
                        <td class="number">134,760</td>
                      </tr>
                      <tr>
                        <td>Outstanding Mutual Value Plan Balances</td>
                        <td class="number">82,272</td>
                        <td class="number">87,463</td>
                        <td class="number">94,376</td>
                        <td class="number">98,304</td>
                        <td class="number">103,025</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ContentSection>
        </div>
        <div class="orbs-bg">
          <div
            class="orb blue"
            style="top: 100px; right: -200px;"
          ></div>
          <ContentSection id="balance-sheets"
                          title="Condensed Balance Sheets"
                          subtext="(as of December 31, 2023 &amp; 2022)"
                          class="financial-section">
            <div class="grid-container">
              <div class="grid-x">
                <div class="cell" data-aos="fade-up">
                  <div class="table-scroll">
                    <table class="align-table-2 right-aligned">
                      <thead>
                      <tr>
                        <th><h4>Assets</h4></th>
                        <th><h4>2023</h4></th>
                        <th><h4>2022</h4></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>Cash &amp; Investments</td>
                        <td class="number">1,442,715,000</td>
                        <td class="number">1,357,781,000</td>
                      </tr>
                      <tr>
                        <td>Premiums Receivable</td>
                        <td class="number">16,635,000</td>
                        <td class="number">15,084,000</td>
                      </tr>
                      <tr>
                        <td>Accrued Investment Income</td>
                        <td class="number">8,747,000</td>
                        <td class="number">7,956,000</td>
                      </tr>
                      <tr>
                        <td>Reinsurance Recoverable</td>
                        <td class="number">3,470,000</td>
                        <td class="number">3,292,000</td>
                      </tr>
                      <tr>
                        <td>Federal Income Taxes Recoverable</td>
                        <td class="number">1,015,000</td>
                        <td class="number">1,287,000</td>
                      </tr>
                      <tr>
                        <td class="bb">Other Assets</td>
                        <td class="bb number">995,000</td>
                        <td class="bb number">231,000</td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <th>TOTAL ASSETS</th>
                        <th class="number">$1,473,577,000</th>
                        <th class="number">$1,385,631,000</th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div class="separate-tables"><!--x--></div>
                  <div class="table-scroll">
                    <table class="align-table-2 right-aligned">
                      <thead>
                      <tr>
                        <th>
                          <h4>Liabilities &amp; Policyholders’ Surplus</h4>
                          <p>Liabilities</p>
                        </th>
                        <th><h4>2023</h4></th>
                        <th><h4>2022</h4></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>Loss &amp; Loss Adjustment Expense Reserves</td>
                        <td class="number">488,000,000</td>
                        <td class="number">461,000,000</td>
                      </tr>
                      <tr>
                        <td>Unearned Premiums</td>
                        <td class="number">72,810,000</td>
                        <td class="number">69,742,000</td>
                      </tr>
                      <tr>
                        <td>Reinsurance Balances Payable</td>
                        <td class="number">23,790,000</td>
                        <td class="number">29,606,000</td>
                      </tr>
                      <tr>
                        <td>Accounts Payable and Accrued Expenses</td>
                        <td class="number">42,446,000</td>
                        <td class="number">41,930,000</td>
                      </tr>
                      <tr>
                        <td>Net Deferred Tax Liabilities</td>
                        <td class="number">18,646,000</td>
                        <td class="number">9,774,000</td>
                      </tr>
                      <tr>
                        <td>Dividends Payable</td>
                        <td class="number">3,350,000</td>
                        <td class="number">2,735,000</td>
                      </tr>
                      <tr>
                        <td class="bb">Other Liabilities</td>
                        <td class="bb number">3,459,000</td>
                        <td class="bb number">4,013,000</td>
                      </tr>
                      <tr>
                        <th>Total Liabilities</th>
                        <th class="number">$652,501,000</th>
                        <th class="number">$618,800,000</th>
                      </tr>
                      </tbody>
                    </table>
                    <br>
                    <table class="align-table-2 right-aligned">
                      <tbody>
                      <tr>
                        <th><p class="sub-title-financial">Policyholders’ Surplus</p></th>
                      </tr>
                      <tr>
                        <td>Expected Mutual Value Plan Obligation</td>
                        <td class="number">$35,933,000</td>
                        <td class="number">$34,031,000</td>
                      </tr>
                      <tr>
                        <td>Unassigned Surplus</td>
                        <td class="number">$785,143,000</td>
                        <td class="number">$732,800,000</td>
                      </tr>
                      <tr>
                        <th style="font-weight: 600;" class="bb">Total Policyholders’ Surplus</th>
                        <th style="font-weight: 600;" class="bb number">$821,076,000</th>
                        <th style="font-weight: 600;" class="bb number">$766,831,000</th>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <th>TOTAL LIABILITIES &amp; POLICYHOLDERS’ SURPLUS</th>
                        <th class="number">$1,473,577,000</th>
                        <th class="number">$1,385,631,000</th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ContentSection>
        </div>
        <div class="orbs-bg">
          <div
            class="orb purple"
            style="top: -200px; left: -200px;"
          ></div>
          <ContentSection id="statements-of-income"
                          title="Condensed Statements of Income"
                          subtext="(For the years ended December 31, 2023 &amp; 2022)"
                          class="financial-section">
            <div class="grid-container">
              <div class="grid-x">
                <div class="cell" data-aos="fade-up">
                  <div class="table-scroll">
                    <table class="align-table-2 right-aligned">
                      <thead>
                        <tr>
                          <th><h4>&nbsp;</h4></th>
                          <th><h4>2023</h4></th>
                          <th><h4>2022</h4></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Gross Written Premium</td>
                          <td class="number">145,691,000</td>
                          <td class="number">137,233,000</td>
                        </tr>
                        <tr>
                          <td>Ceded Premium</td>
                          <td class="number">(16,712,000)</td>
                          <td class="number">(27,228,000)</td>
                        </tr>
                        <tr style="border-top: 1px solid black !important;">
                          <td>Net Written Premium</td>
                          <th class="number">$128,979,000</th>
                          <th class="number">$110,005,000</th>
                        </tr>
                        <tr>
                          <td>Change in Unearned Premium</td>
                          <td class="number">(3,068,000)</td>
                          <td class="number">(3,880,000)</td>
                        </tr>
                        <tr style="border-top: 1px solid black !important;">
                          <td>Net Earned Premium</td>
                          <th class="number no-extra-padding">$125,911,000</th>
                          <th class="number no-extra-padding">$106,125,000</th>
                        </tr>
                        <tr class="spacer-row"></tr>
                        <tr>
                          <td>Loss &amp; Loss Adjustment Expenses Incurred</td>
                          <td class="number">107,595,000</td>
                          <td class="number">83,832,000</td>
                        </tr>
                        <tr>
                          <td>Other Underwriting Expenses</td>
                          <td class="number">26,900,000</td>
                          <td class="number">25,166,000</td>
                        </tr>
                      </tbody>
                      <tbody class="bl-border">
                        <tr>
                          <td>Net Underwriting Income</td>
                          <th class="number">($8,584,000)</th>
                          <th class="number">($2,873,000)</th>
                        </tr>
                        <tr class="spacer-row"></tr>
                        <tr>
                          <td>Net Investment Income</td>
                          <td class="number">35,550,000</td>
                          <td class="number">35,345,000</td>
                        </tr>
                        <tr>
                          <td>Net Realized Capital Gains (Losses) on Investments</td>
                          <td class="number">1,365,000</td>
                          <td class="number">(678,000)</td>
                        </tr>
                        <tr>
                          <td>Other Income (Expense)</td>
                          <td class="number">(122,000)</td>
                          <td class="number">(10,000)</td>
                        </tr>
                        <tr style="border-top: 1px solid black !important;">
                          <td>Net Income Before Taxes and Policyholders’ Dividends</td>
                          <td class="number bold">$28,209,000</td>
                          <td class="number bold">$31,784,000</td>
                        </tr>
                        <tr>
                          <td class="bb">Policyholders’ Dividends &amp; Federal Income Taxes Incurred</td>
                          <td class="bb number">(11,921,000)</td>
                          <td class="bb number">(10,115,000)</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td>Net Income</td>
                          <td class="number">$16,288,000</td>
                          <td class="number">$21,669,000</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <div class="grid-x">
                <div class="cell large-7 medium-9">
                  <p class="note">Note: The financial statements have been prepared in conformity with accounting practices
                    prescribed or permitted by the Tennessee Department of Commerce and Insurance. The condensed financial
                    information has been derived from the complete statutory-basis financial statements which were audited
                    by Ernst &amp; Young LLP, our independent auditors. A complete set of audited financial statements is
                    available upon request.</p>
                </div>
              </div>
            </div>
          </ContentSection>
        </div>
        <div class="orbs-bg">
          <div
            class="orb blue"
            style="top: -400px; right: -400px;"
          ></div>
          <ContentSection id="mvp-allocations"
                          title="Mutual Value Plan&reg; Allocations">
            <div class="grid-container">
              <ChartContainer>
                <MvpAllocationsChart/>
              </ChartContainer>
              <p class="note chart-note">Established in 2018</p>
            </div>
          </ContentSection>
        </div>
        <div class="orbs-bg">
          <div
            class="orb purple"
            style="top: -300px; left: -400px;"
          ></div>
          <ContentSection id="mvp-distributions"
                          title="Cumulative Mutual Value Plan&reg; Distributions">
            <div class="grid-container">
              <ChartContainer>
                <MvpDistributionsChart/>
              </ChartContainer>
              <p class="note chart-note">Established in 2018</p>
            </div>
          </ContentSection>
        </div>
        <div class="orbs-bg">
          <div
            class="orb blue"
            style="top: -400px; right: -400px;"
          ></div>
          <ContentSection id="policyholders-surplus"
                          title="Policyholders' Surplus &amp; Total Assets"
                          class="financial-section">
            <div class="grid-container">
              <div class="chart-label-container"
                   data-aos="fade-down">
                <div class="grid-x">
                  <div class="large-3 small-6">
                    <div class="chart-label">
                      <div class="dot label2">
                      </div>
                      <p>Policyholders’ Surplus</p>
                    </div>
                  </div>
                  <div class="large-3 small-6">
                    <div class="chart-label">
                      <div class="dot label1">
                      </div>
                      <p>Total Assets</p>
                    </div>
                  </div>
                </div>
              </div>
              <ChartContainer chartClass="chart-container-policyholders-surplus">
                <PolicyholdersSurplusChart/>
              </ChartContainer>
            </div>
          </ContentSection>
        </div>
        <div class="orbs-bg">
          <div
            class="orb purple"
            style="top: -300px; left: -400px;"
          ></div>
          <ContentSection id="cumulative-dividends"
                          title="Cumulative Dividends Declared &amp; Return of Capital">
            <div class="grid-container">
              <ChartContainer chartClass="chart-container-cumulative-dividends">
                <CumulativeDividendsChart/>
              </ChartContainer>
            </div>
          </ContentSection>
        </div>
        <TheSubFooter next-route="/leadership" />
      </div>
    </DefaultPage>
  </div>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import TheSubFooter from '@/components/footer/TheSubFooter';
import ContentSection from '@/components/section/VisualDataSection';
import MvpAllocationsChart from '@/components/chart/MvpAllocationsChart';
import MvpDistributionsChart from '@/components/chart/MvpDistributionsChart';
import PolicyholdersSurplusChart from '@/components/chart/PolicyholdersSurplusChart';
import ChartContainer from '@/components/chart/ChartContainer';
import CumulativeDividendsChart from '@/components/chart/CumulativeDividendsChart';

export default {
  name: 'Financials',
  components: {
    MvpAllocationsChart,
    MvpDistributionsChart,
    CumulativeDividendsChart,
    ChartContainer,
    PolicyholdersSurplusChart,
    ContentSection,
    TheSubFooter,
    DefaultPage
  },
  data () {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/setup/variables.scss';
#mvp-allocations {
  .cell:first-of-type {
    margin-bottom: 4rem;
    @include breakpoint(large) {
      margin-bottom: 0;
    }
  }
}
</style>
